import React, {
    createRef,
    FunctionComponent,
    useEffect,
    useState,
} from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import { default as Input } from '@material-ui/core/Input/Input';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useDebounce } from '../../shared/useDebounce';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        // buttonMargin: {
        //     marginLeft: theme.spacing(1),
        // },
        // inputRoot: {
        //     fontSize: theme.typography.h4.fontSize,
        // },
        // inputLabelRoot: {
        //     fontSize: theme.typography.h4.fontSize,
        // },
        // inputLabelShrink: {
        //     transform: 'translate(0, 1.5px) scale(0.50);',
        // },
        progress: {
            color: theme.palette.grey['600'],
            visibility: 'hidden',
        },
        progressVisible: {
            visibility: 'visible',
        },
    }),
);

interface SearchFieldProps {
    onReset?: () => any;
    onChange: (val: string) => any;
    loading?: boolean;
    autoFocus?: boolean;
    label?: string;
    value: string;
}

export const SearchField: FunctionComponent<SearchFieldProps> = ({
    onReset,
    onChange,
    loading,
    autoFocus,
    label,
    value,
}) => {
    const [t] = useTranslation();
    const classes = useStyles();

    const [isInitial, setIsInitial] = useState<boolean>(true);
    const [text, setText] = useState<string>('');
    const inputRef = createRef<HTMLInputElement>();

    useDebounce(() => {
        if (!isInitial) onChange(text);

        if (isInitial) setIsInitial(false);
    }, [text]);

    useEffect(() => {
        setText(value);
    }, [value]);

    const inputActions = (
        <InputAdornment position="end">
            <CircularProgress
                size={28}
                className={
                    classes.progress +
                    (loading ? ' ' + classes.progressVisible : '')
                }
            />
            <IconButton
                type="reset"
                aria-label={t('Reset input field')}
                onClick={() => {
                    setText('');
                    inputRef.current?.focus();
                    if (typeof onReset === 'function') onReset();
                }}
            >
                <CloseIcon />
            </IconButton>
        </InputAdornment>
    );

    return (
        <FormControl fullWidth>
            <InputLabel
                classes={
                    {
                        // root: classes.inputLabelRoot,
                        // shrink: classes.inputLabelShrink,
                    }
                }
                htmlFor="search-field"
            >
                {label}
            </InputLabel>
            <Input
                type="text"
                id="search-field"
                name={`questions-${Math.random()}`}
                endAdornment={inputActions}
                value={text}
                onChange={(ev) => setText(ev.target.value)}
                fullWidth
                inputRef={inputRef}
                autoFocus={autoFocus}
                classes={
                    {
                        // root: classes.inputRoot,
                    }
                }
            />
        </FormControl>
    );
};
